import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowDiscounts from '../components/discounts/ShowDiscounts';
import { fetchItems, fetchProducts, clearAuthErrors, fetchDiscounts, disableDiscount, clearDiscountsErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  discounts: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};


class DiscountsPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    this.props.dispatch(clearDiscountsErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.discounts.search && this.props.discounts.search.length > 0) {
      query.search = this.props.discounts.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/discounts', query });
    } else {
      const getLimit = { limit: 1000 };
      this.props.dispatch(fetchDiscounts(query));
      this.props.dispatch(fetchProducts(getLimit));
      this.props.dispatch(fetchItems(getLimit));
      // this.props.dispatch(fetchDiscounts(query));
    }
  }
  onDiscountDisable(data) {
    const pData = data;
    this.props.dispatch(disableDiscount(pData));
  }
  handleSearchChange(e) {
    const discounts = this.props.discounts;
    const query = this.props.query;
    const router = this.props.router;
    const nextName = e.target.value;
    discounts.search = nextName;
    this.setState({
      discounts,
    });
    if (nextName.length > 0) {
      query.search = nextName;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/discounts', query });
    this.props.dispatch(fetchDiscounts(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchDiscounts(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="discount component" style={authPage}>
        <h2>Discounts</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to={'/discounts/new'}>
              <RaisedButton
                label="Add New Discount"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.discounts.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.discounts.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowDiscounts
            discounts={this.props.discounts}
            onDiscountDisable={data => this.onDiscountDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.discounts.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

DiscountsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

DiscountsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    discounts: state.discounts,
    products: state.products,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(DiscountsPage));



// WEBPACK FOOTER //
// ./src/containers/DiscountsPage.js